import React from "react";
import { Link } from "react-router-dom";

import { CourseCard, Title } from "..";

import { courses } from "../../assets/data/data";

const Courses = () => {
  return (
    <section className="courses">
      <div className="container">
        <Title title="Kursevi"  />
        <div className="row gx-4 gy-5">
          {courses
            
            .map((item) => (
              <CourseCard {...item} key={item.id} />
            ))}
        </div>
       
      </div>
    </section>
  );
};

export default Courses;
